/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface CustomQuestionnaireFreeTextAnswer
 */
export interface CustomQuestionnaireFreeTextAnswer {
  /**
   *
   * @type {number}
   * @memberof CustomQuestionnaireFreeTextAnswer
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof CustomQuestionnaireFreeTextAnswer
   */
  value?: string | null;
}

/**
 * Check if a given object implements the CustomQuestionnaireFreeTextAnswer interface.
 */
export function instanceOfCustomQuestionnaireFreeTextAnswer(value: object): value is CustomQuestionnaireFreeTextAnswer {
  if (!('id' in value) || value['id'] === undefined) return false;
  return true;
}

export function CustomQuestionnaireFreeTextAnswerFromJSON(json: any): CustomQuestionnaireFreeTextAnswer {
  return CustomQuestionnaireFreeTextAnswerFromJSONTyped(json, false);
}

export function CustomQuestionnaireFreeTextAnswerFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CustomQuestionnaireFreeTextAnswer {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    value: json['value'] == null ? undefined : json['value'],
  };
}

export function CustomQuestionnaireFreeTextAnswerToJSON(
  value?: Omit<CustomQuestionnaireFreeTextAnswer, 'id'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    value: value['value'],
  };
}
